import { CustomSelect, Label, SelectOption } from '@consigli/facade';
import { EmployerRole } from '@consigli/types';
import { FC } from 'react';
import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface SelectEmployerRoleProps {
  label?: string;
}

export const SelectEmployerRole: FC<SelectEmployerRoleProps> = () => {
  const { t } = useTranslation();

  const { control } = useFormContext<FieldValues>();
  const {
    field: employerRoleField,
    fieldState: { error },
  } = useController({
    name: 'employerRole',
    control,
    rules: { required: t('employer-role.required') },
  });

  const employerRoleOptions: SelectOption[] = [
    {
      label: t('employer-role.CONSULTANT'),
      value: EmployerRole.CONSULTANT,
    },
    {
      label: t('employer-role.CONTRACTOR'),
      value: EmployerRole.CONTRACTOR,
    },
    {
      label: t('employer-role.DEVELOPER'),
      value: EmployerRole.DEVELOPER,
    },
    {
      label: t('employer-role.PROJECT_DEVELOPER'),
      value: EmployerRole.PROJECT_DEVELOPER,
    },
    {
      label: t('employer-role.ENGINEER'),
      value: EmployerRole.ENGINEER,
    },
  ];

  return (
    <div className="mb-4">
      <Label text={t('employer-role.heading')} />
      <p className="mb-2 text-xs text-gray-500">{t('employer-role.helper')}</p>
      <CustomSelect
        onChange={(selectedOptions: SelectOption[]) => {
          employerRoleField.onChange(selectedOptions.length > 0 ? selectedOptions[0].value : null);
        }}
        options={employerRoleOptions}
        value={
          employerRoleField.value
            ? employerRoleOptions.filter((option) => option.value === employerRoleField.value)
            : []
        }
        noOptionsMessage={t('custom-select.no-options')}
      />
      {error && <p className="mt-1 text-sm text-red-500">{error.message}</p>}
    </div>
  );
};
